import { merge } from 'lodash-es';
import { isPeriodOverPeriodChart } from './period-over-period.helpers';
import { CHART_TYPES } from '../enums';
import { hasYAxisFormattingOptions } from './y-axis-symbol-config-builder';

export default (config, chartJSConfig, context) => {
  const isTimeAxisType = ['SINGLE_TIME_FIELD'].includes(config.xAxisType);
  if (isTimeAxisType || isPeriodOverPeriodChart(config)) {
    return chartJSConfig;
  }

  /**
   * If the @property {string} config.series[0].seriesType is equal to 'HORIZONTAL_BAR', and the @param config has the functionality of @function yAxisFormattingOptions(), the buiilder will formatt the x axis by precentage and not by the common behavior to formatt a segment.
   */
  // eslint-disable-next-line max-len
  if (config.series[0].seriesType === CHART_TYPES.HORIZONTAL_BAR && hasYAxisFormattingOptions(config.yAxisFormattingOptions)) {
    /* eslint-disable */
    const formatObject = { options: { scales: { x: { ticks: config.yAxisFormattingOptions } } } };
    return merge(chartJSConfig, formatObject);
  }

  const callback = function (value, index, values) {
    let { width } = context.getBoundingClientRect();

    // Removing buffers from the width to make sure I don't overflow
    width -= 100;

    const allowedFraction = width / (values.length || 1);

    // This means that it's not a linear axis
    if (value === index) {
      // eslint-disable-next-line no-invalid-this
      let result = this.getLabelForValue(value);
      const textWidth = getTextWidth(result, 12) || 1;

      if (textWidth > allowedFraction) {
        // Creating all the subsets of the title
        const options = Array.from(
          { length: result.length - 1 },
          (v, i) => `${result.substr(0, i + 1).trim()}...`
        );

        // Finding the first result that's smaller.
        result = options.reverse().reduce((result, nextOption) => {
          return result
            ? result
            : (getTextWidth(nextOption, 12) || 1) <= allowedFraction
              ? nextOption
              : null;
        }, null);
      }

      return result;
    }

    return value;
  };

  const callbackObject = { options: { scales: { x: { ticks: { callback } } } } };

  return merge(chartJSConfig, callbackObject);
};


const getTextWidth = (string, fontSize) => {
  const text = document.createElement('span');
  document.body.appendChild(text);

  text.style.fontSize = `${fontSize}px`;
  text.style.fontWeight = 400;
  text.style.fontFamily = 'Open Sans';
  text.style.height = 'auto';
  text.style.width = 'auto';
  text.style.lineHeight = '9px';
  text.style.position = 'absolute';
  text.style.whiteSpace = 'no-wrap';
  text.innerHTML = string;

  const width = text.clientWidth;
  document.body.removeChild(text);

  return width;
};
